"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const OfferLabelsView = ({ extraLabelList, direction, }) => react_1.default.createElement("div", { className: `extra-labels ${direction === 'row' ? 'extra-labels--row' : ''}` }, extraLabelList.length > 0
    && react_1.default.createElement(react_1.default.Fragment, null, extraLabelList.map((label) => react_1.default.createElement("div", { key: label, className: "label" }, label))));
exports.default = OfferLabelsView;
